import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { ClientRegisteredVendor } from './client-registered-vendor';
import { Company } from './company';
import { Email } from './email';
import { ExemptVendor } from './exempt-vendor';
import { ProposalRequest } from './proposal-request';
import { User } from './user';
import { Vendor } from './vendor';
import { ViveProgress } from './vive-progress';
import { ZendeskTicket } from './zendesk-ticket';

export class Note extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static NoteProperties: (
    | {
        property: keyof Note;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof Note;
        type: 'alias';
      }
    | {
        property: keyof Note;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'ExemptVendorId', type: 'column', dataType: 'number' },
    {
      property: 'ClientRegisteredVendorId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'modelId', type: 'column', dataType: 'number' },
    { property: 'modelType', type: 'column', dataType: 'string' },
    { property: 'title', type: 'column', dataType: 'string' },
    { property: 'note', type: 'column', dataType: 'string' },
    { property: 'UserId', type: 'column', dataType: 'number' },
    { property: 'isSystemGenerated', type: 'column', dataType: 'boolean' },
    { property: 'isAuditNote', type: 'column', dataType: 'boolean' },
    { property: 'isEmailNote', type: 'column', dataType: 'boolean' },
    { property: 'isBusinessOverrideNote', type: 'column', dataType: 'boolean' },
    { property: 'ticketId', type: 'column', dataType: 'number' },
    { property: 'isSensitive', type: 'column', dataType: 'boolean' },
    { property: 'EmailId', type: 'column', dataType: 'number' },
    { property: 'ProposalRequestId', type: 'column', dataType: 'number' },
    { property: 'isApNote', type: 'column', dataType: 'boolean' },
    { property: 'isChangeLog', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'communicationType', type: 'alias' },
    { property: 'userType', type: 'alias' },

    { property: 'Vendor', model: 'Vendor', type: 'association' },
    { property: 'Company', model: 'Company', type: 'association' },
    { property: 'User', model: 'User', type: 'association' },
    { property: 'ZendeskTicket', model: 'ZendeskTicket', type: 'association' },
    {
      property: 'ClientRegisteredVendor',
      model: 'ClientRegisteredVendor',
      type: 'association'
    },
    { property: 'ExemptVendor', model: 'ExemptVendor', type: 'association' },
    {
      property: 'ProposalRequest',
      model: 'ProposalRequest',
      type: 'association'
    },
    { property: 'Email', model: 'Email', type: 'association' }
  ];

  static {
    Note.NoteProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        Note.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        Note.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        Note.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(NoteObject: Partial<Note>) {
    super();

    Note.NoteProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = NoteObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  CompanyId?: number | null;
  VendorId?: number | null;
  ExemptVendorId?: number | null;
  ClientRegisteredVendorId?: number | null;
  modelId?: number;
  modelType?: 'vendor' | 'company' | 'site' | 'companyVendor' | 'viveProgress';
  modelTable?: string;
  title?: string;
  note?: string;
  UserId?: number | null;
  isSystemGenerated?: boolean;
  isAuditNote?: boolean;
  isEmailNote?: boolean;
  isBusinessOverrideNote?: boolean;
  ticketId?: null | string;
  isSensitive?: boolean;
  EmailId?: number | null;
  ProposalRequestId?: number | null;
  ViveProgressId?: number | null;
  isApNote?: boolean;
  isChangeLog?: boolean;
  isArchived?: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  // Aliased columns
  communicationType?: string;
  userType?: string;

  Vendor?: Vendor;
  Company?: Company;
  User?: User;
  ZendeskTicket?: ZendeskTicket;
  ExemptVendor?: ExemptVendor;
  ClientRegisteredVendor?: ClientRegisteredVendor;
  ProposalRequest?: ProposalRequest;
  Email?: Email;
  ViveProgress?: ViveProgress;
}

/*


module.exports = (sequelize, DataTypes) => {
  Note.associate = (models) => {
    Note.belongsTo(models.Email);
    Note.belongsToMany(models.UserAccountType, { through: models.UserAccountTypeNote });
    Note.hasMany(models.UserAccountTypeNote, { foreignKey: 'NoteId' });
  };

  return Note;
};
*/
